// extracted by mini-css-extract-plugin
module.exports = {"column":"IconText_column__joWBO"};